import type { NormalizedOptions } from "ky";
import ky from "ky";
import { problemDetailsErrorHook } from "ls/api/common/server";
import { serverApiUrl } from "ls/api/urls";
import { read } from "@/common/lib/cookies";
import { isFormData } from "@/common/lib/guards";

export const server = ky.create({
  prefixUrl: serverApiUrl,
  credentials: import.meta.env.DEV ? "include" : undefined,
  retry: { limit: 0 },
  timeout: import.meta.env.DEV ? false : undefined,
  hooks: {
    beforeRequest: [
      csrfTokenHook,
    ],
    beforeError: [
      problemDetailsErrorHook,
    ],
  },
});

function shouldFetchCsrfToken(request: Request, options: NormalizedOptions) {
  if (request.method === "GET" || options.method === "HEAD") return false;
  if (hasCsrfToken()) return false;
  if (isFormData(options.body)) return true;
  return false;
}

async function csrfTokenHook(request: Request, options: NormalizedOptions) {
  if (shouldFetchCsrfToken(request, options)) {
    await server.get("antiforgery/token");
  }

  const token = getCsrfToken();
  if (token) {
    request.headers.set("X-XSRF-TOKEN", token);
  }
}

function getCsrfToken() {
  return read("XSRF-TOKEN");
}

function hasCsrfToken() {
  return !!getCsrfToken();
}
